import React from 'react';

import classNames from 'classnames';

import './LoadingDots.scss';

type LoadingDotsProps = {
  className?: string;
};

function LoadingDots({ className }: LoadingDotsProps) {
  return (
    <span className={classNames('LoadingDots', className)}>
      <span />
      <span />
      <span />
    </span>
  );
}

export { LoadingDots };
